const SCREENERS = {
    BOUNCEBEAR: "bounce_bearish",
    BOUNCEBULL: "bounce_bullish",
    SQUEEZEBEAR: "bearish_squeeze",
    SQUEEZEBULL: "bullish_squeeze",
    SQUEEZEBASIC: "basic_squeeze",
    COUNTERTRENDSHORT: "countertrend_short",
    COUNTERTRENDLONG: "countertrend_long",
}
export default SCREENERS